
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quem-somos",
      function () {
        return require("private-next-pages/quem-somos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quem-somos"])
      });
    }
  